import { Format as CmsFormat, type FormattingState } from '@helo/cms'
import { pipe } from '@helo/utils'

import {
  formatUTCDate,
  parseUTCDateString,
  toWallClockDateString,
} from '../../utils/dates'
import { Options } from '../Options'
import { formatOptions } from './Format.options'

const isNamedDateFormat = (value: string | undefined) =>
  value === 'iso' || value === 'short' || value === 'medium' || value === 'long'

const date =
  (state: FormattingState = {}) =>
  (value: unknown): string => {
    const dateFormat =
      typeof state.dateFormat === 'string' ? state.dateFormat : undefined
    if (
      dateFormat != null &&
      dateFormat.length > 0 &&
      !isNamedDateFormat(dateFormat)
    ) {
      const raw = typeof value === 'string' ? value : String(value ?? '')
      const parsed = parseUTCDateString(raw)
      if (parsed == null)
        return CmsFormat.date(state)(toWallClockDateString(value))
      return formatUTCDate(parsed, dateFormat).replace(/\\n/g, '\n')
    }
    return CmsFormat.date(state)(toWallClockDateString(value))
  }

const resolve =
  (
    sources: Array<
      object | ((ctx: { input: object; output: unknown }) => object)
    > = [],
  ) =>
  (ctx: { input: object; output: unknown }) => {
    let next = ctx
    for (const source of sources) {
      next = Options.fallback(formatOptions, source)(next)
    }
    return pipe(
      next,
      Options.applyDefaults(formatOptions),
      Options.validate(formatOptions),
    )
  }

export const FormatParts = {
  isNamedDateFormat,
  date,
  resolve,
}
